import React, { useCallback, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { MdSearch as SearchIcon } from '@react-icons/all-files/md/MdSearch';
import clsx from 'clsx';
import Popper from 'src/components/Popper';
import ClickAwayListener from '../../../ClickAwayListener';
import ResultItem from '../../SearchBar/components/ResultItem';
import SearchBar from '../../SearchBar';

const useStyles = createUseStyles({
  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    fill: '#3f4d67',
    '&:hover': {
      fill: '#0e141d',
    },
  },
  root: {
    zIndex: 15,
  },
  result: {
    marginLeft: 30,
    marginRight: 30,
    marginBottom: 5,
  },
  menu: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    boxShadow: '0 0 35px 0 rgba(154,161,171,.15)',
    padding: '.25rem 0',
    border: '1px solid #e4eaf2',
    borderRadius: '.25rem',
    marginTop: 10,
  },
  searchBar: {
    margin: '5px 10px',
    maxWidth: 'inherit',
    width: 'auto',
  },
});

const SearchDropDown = ({ className }) => {
  const classes = useStyles();

  const [menuOpen, setMenuOpen] = useState(false);
  const [iconRef, setIconRef] = useState<HTMLElement | null>(null);

  const hideMenu = useCallback(() => {
    setMenuOpen(false);
  }, [setMenuOpen]);

  const showMenu = useCallback(() => {
    setMenuOpen(true);
  }, [setMenuOpen]);

  return (
    <div className={clsx(classes.root, className)}>
      {iconRef && menuOpen && (
        <Popper fullWidth anchorEl={iconRef}>
          <ClickAwayListener onClickAway={hideMenu}>
            <div className={classes.menu}>
              <SearchBar
                className={classes.searchBar}
                onReset={hideMenu}
                renderResults={(results, { reset }) =>
                  Object.values(results)
                    .reduce((list, value) => list.concat(value), [])
                    .map((item, key) => <ResultItem className={classes.result} item={item} key={key} onClick={reset} />)
                }
              />
            </div>
          </ClickAwayListener>
        </Popper>
      )}

      <div ref={setIconRef}>
        <SearchIcon className={classes.icon} size={20} onClick={showMenu} />
      </div>
    </div>
  );
};

export default SearchDropDown;
